var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88.209,
    height: 63,
    viewBox: "0 0 88.209 63"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle arrondi 1",
    width: 88.209,
    height: 7.031,
    rx: 3,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle arrondi 1 copie",
    width: 88.209,
    height: 7.031,
    rx: 3,
    transform: "translate(0 27.985)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle arrondi 1 copie 2",
    width: 88.209,
    height: 7,
    rx: 3,
    transform: "translate(0 56)",
    fill: "#fff"
  })));
};
export default SvgBurger;